import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";

export interface PageBreadcrumb {
  route: string;
  name: string;
}

@Component({
    selector: 'breadcrumb',
    template: `
    <section class="section-breadcrumb notranslate" translate="no">
      <div class="container">
        @for (currentPage of paginas; track currentPage;let index = $index) {
          <a
            href="javascript:void(0)"
            routerLink="{{currentPage.route}}"
            title="{{currentPage.name}}"
            [attr.aria-label]="currentPage.name"
            class="notranslate"
            translate="no"
          >
            {{currentPage.name}}
          </a>
          <span *ngIf="index + 1 < paginas.length"> / </span>
        }
      </div>
    </section>
  `,
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: true,
    imports: [RouterLink,CommonModule]
})

export class BreadcrumbComponent {
  @Input() paginas: PageBreadcrumb[] = [];
}
